import {neptuneAssetUrl} from "~/utilities/neptuneAssetUrl";
import {useAnankePreferences} from "@vesta/ananke/contexts/anankeClientContext";

const loaderAssetBaseUrl = neptuneAssetUrl("static/loaderAnimation");

export function IntellsysLoadingOverlay(_props: {message?: string}) {
    const {theme} = useAnankePreferences();

    return (
        <div className="w-full h-svh p-4">
            <div className="w-full max-w-[40rem] h-full mx-auto relative">
                <img
                    src={theme === "dark" ? `${loaderAssetBaseUrl}/dark/circleBackground.svg` : `${loaderAssetBaseUrl}/light/circleBackground.svg`}
                    className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[40%]"
                    alt=""
                />
                <img
                    src={theme === "dark" ? `${loaderAssetBaseUrl}/dark/lineBackground.svg` : `${loaderAssetBaseUrl}/light/lineBackground.svg`}
                    className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[100%]"
                    alt=""
                />
                {/* <img
                        src={theme === "dark" ? `${loaderAssetBaseUrl}/dark/allColors.svg` : `${loaderAssetBaseUrl}/light/allColors.svg`}
                        class="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 100%"
                        alt=""
                    /> */}
                <img
                    src={`${loaderAssetBaseUrl}/intellsysCircle.svg`}
                    className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[50%]"
                    alt="intellsys logo"
                />
                {/* #region Added for debugging font loading */}
                {/* <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[100%] text-center text-[1.125rem] line-clamp-1 break-all">
                    {_props.message ?? "Loading..."}
                </div> */}
                {/* #endregion */}
            </div>
        </div>
    );
}
